import axios from 'axios';

const Api_Url = "https://mobikode-backend.vercel.app";
// const Api_Url = "http://localhost:8080";

const Get_Api = async (EndPoint) => {
  try {
    const response = await axios.get(`${Api_Url}/${EndPoint}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};


const Delete_Api = async (EndPoint) => {
  try {
    const response = await axios.delete(`${Api_Url}/${EndPoint}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting data:', error);
    throw error;
  }
};

const Create_Api = async (EndPoint, data) => {
  try {
    const response = await axios.post(`${Api_Url}/${EndPoint}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating data:', error);
    throw error;
  }
};

const Update_Api = async (EndPoint, data) => {
  try {
    const response = await axios.put(`${Api_Url}/${EndPoint}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating data:', error);
    throw error;
  }
};

const Update_with_token_Api = async (EndPoint, data) => {
  try {
    const token = localStorage.getItem('AdminToken')
    console.log(token)

    const response = await axios.put(`${Api_Url}/${EndPoint}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error updating data:', error);
    throw error;
  }
};

const Create_Api_Formdata = async (EndPoint, data) => {
  try {
    const response = await axios.post(`${Api_Url}/${EndPoint}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data', 
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating data:', error);
    throw error;
  }
};
const Update_Api_Formdata = async (EndPoint, data) => {
  try {
    const response = await axios.put(`${Api_Url}/${EndPoint}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data', 
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating data:', error);
    throw error;
  }
};



const formatDate = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
const formatDateonly = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};


export { Get_Api, Delete_Api, formatDate, Create_Api, Update_Api, Update_with_token_Api,Create_Api_Formdata,Update_Api_Formdata,formatDateonly };
